export default {
  paginaAtual: 1,
  estaCarregando: false,
  todosItensCarregados: false,
  totalItens: null,
  lista: [],
  itemSelecionadoID: null,
  objFormularioFollowUp: {
    descricao_formulario: '',
    follow_up_inicial: false,
    formulario_convenio: false
  },
  filtros: {
    situacao: null,
    follow_up_inicial: null,
    formulario_convenio: null
  }
}
